import { useEffect, useState } from "react";

import styled from "@emotion/styled";

import gifScroll from "../../../assets/media/gifScroll.gif";

function ScrollDownIcon() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // const scrollTop = document.documentElement.scrollTop;
      const scrollTop =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;

      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.offsetHeight;
      const scrollPercentage = (scrollTop / (fullHeight - windowHeight)) * 100;

      if (scrollPercentage > 80) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Styles style={{ display: visible ? "block" : "none" }}>
      <img src={gifScroll} alt="gifScroll" />
    </Styles>
  );
}

export default ScrollDownIcon;

const Styles = styled.span`
  position: fixed;
  bottom: 20px;
  left: 9%;
  transform: translateX(-50%);
  transition: opacity 0.3s ease;
  opacity: 0.2;
  img {
    width: 50px;
    height: 50px;
  }
`;
